import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights } from '../../defaultTheme';
import query from '../../const/mediaQueries';
const H5 = styled.h5 `
  font-size: ${fontSizes.medium}px;
  line-height: ${lineHeights.larger};
  font-weight: ${({ weight }) => fontWeights[weight || 'regular']};
  margin: 0;

  &:focus {
    outline: none;
  }

  @media ${query.lessThanMedium} {
    font-size: ${fontSizes.root}px;
  }
`;
export default H5;
